// extracted by mini-css-extract-plugin
export var alertWrapper = "table-module--alert-wrapper--5808b";
export var noPointer = "table-module--noPointer--61122";
export var pointer = "table-module--pointer--4fb88";
export var resizer = "table-module--resizer--ef5e4";
export var results = "table-module--results--51fab";
export var scrollViewWrapper = "table-module--scroll-view-wrapper--11d4d";
export var tableColumnCellWrapper = "table-module--tableColumnCellWrapper--d9ca4";
export var tableColumnCellWrapperDisabled = "table-module--tableColumnCellWrapperDisabled--5041a";
export var tableHeaderArea = "table-module--table-header-area--a4bc0";